// src/models/accounting/chartOfAccountsModel.js

export const ACCOUNT_TYPES = {
  ASSET: 'asset',
  LIABILITY: 'liability',
  EQUITY: 'equity',
  INCOME: 'income',
  EXPENSE: 'expense',
};

export const ACCOUNT_TYPE_LABELS = {
  [ACCOUNT_TYPES.ASSET]: 'Activo',
  [ACCOUNT_TYPES.LIABILITY]: 'Pasivo',
  [ACCOUNT_TYPES.EQUITY]: 'Patrimonio Neto',
  [ACCOUNT_TYPES.INCOME]: 'Ingresos',
  [ACCOUNT_TYPES.EXPENSE]: 'Gastos',
};

export const createAccount = (data = {}) => ({
  id: data.id || '',
  code: data.code || '',
  name: data.name || '',
  parentCode: data.parentCode || null,
  type: data.type || ACCOUNT_TYPES.ASSET,
  description: data.description || '',
  isActive: data.isActive !== undefined ? data.isActive : true,
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: data.updatedAt || new Date().toISOString(),
});

// Plan de cuentas por defecto (configurable)
export const DEFAULT_CHART_OF_ACCOUNTS = [
  // ACTIVO
  { code: '100000', name: 'Activo', type: ACCOUNT_TYPES.ASSET, parentCode: null },
  { code: '110000', name: 'Activo No Corriente', type: ACCOUNT_TYPES.ASSET, parentCode: '100000' },
  { code: '111000', name: 'Inmovilizado Material', type: ACCOUNT_TYPES.ASSET, parentCode: '110000' },
  { code: '120000', name: 'Activo Corriente', type: ACCOUNT_TYPES.ASSET, parentCode: '100000' },
  { code: '430000', name: 'Clientes', type: ACCOUNT_TYPES.ASSET, parentCode: '120000' },
  { code: '472000', name: 'H.P. IVA Soportado', type: ACCOUNT_TYPES.ASSET, parentCode: '120000' },
  { code: '570000', name: 'Caja', type: ACCOUNT_TYPES.ASSET, parentCode: '120000' },
  { code: '572000', name: 'Bancos e instituciones de crédito', type: ACCOUNT_TYPES.ASSET, parentCode: '120000' },

  // PASIVO
  { code: '200000', name: 'Pasivo', type: ACCOUNT_TYPES.LIABILITY, parentCode: null },
  { code: '210000', name: 'Pasivo No Corriente', type: ACCOUNT_TYPES.LIABILITY, parentCode: '200000' },
  { code: '220000', name: 'Pasivo Corriente', type: ACCOUNT_TYPES.LIABILITY, parentCode: '200000' },
  { code: '410000', name: 'Proveedores', type: ACCOUNT_TYPES.LIABILITY, parentCode: '220000' },
  { code: '477000', name: 'H.P. IVA Repercutido', type: ACCOUNT_TYPES.LIABILITY, parentCode: '220000' },
  { code: '475000', name: 'H.P. Acreedora', type: ACCOUNT_TYPES.LIABILITY, parentCode: '220000' },

  // PATRIMONIO NETO
  { code: '300000', name: 'Patrimonio Neto', type: ACCOUNT_TYPES.EQUITY, parentCode: null },
  { code: '310000', name: 'Capital Social', type: ACCOUNT_TYPES.EQUITY, parentCode: '300000' },

  // INGRESOS
  { code: '700000', name: 'Ingresos', type: ACCOUNT_TYPES.INCOME, parentCode: null },
  { code: '710000', name: 'Ventas / Ingresos', type: ACCOUNT_TYPES.INCOME, parentCode: '700000' },

  // GASTOS
  { code: '600000', name: 'Gastos', type: ACCOUNT_TYPES.EXPENSE, parentCode: null },
  { code: '610000', name: 'Compras / Gastos', type: ACCOUNT_TYPES.EXPENSE, parentCode: '600000' },
  { code: '620000', name: 'Servicios Exteriores', type: ACCOUNT_TYPES.EXPENSE, parentCode: '600000' },
];